module.exports = __webpack_public_path__ + "img/e4_img2.0b7fa1b.webp";